/**
 * Do not edit this file it is auto-generated by io-utils / gen-api-models.
 * See https://github.com/pagopa/io-utils
 */
/* eslint-disable  */

import { ScriptParameter } from "./ScriptParameter";
import * as t from "io-ts";

/**
 * The information about the script to be executed by Mocker if all the conditions occurs.
 */

// required attributes
const MockScriptingR = t.interface({
  input_parameters: t.readonlyArray(
    ScriptParameter,
    "array of ScriptParameter"
  ),

  is_active: t.boolean,

  script_name: t.string
});

// optional attributes
const MockScriptingO = t.partial({
  description: t.string,

  output_parameters: t.readonlyArray(t.string, "array of string")
});

export const MockScripting = t.intersection(
  [MockScriptingR, MockScriptingO],
  "MockScripting"
);

export type MockScripting = t.TypeOf<typeof MockScripting>;
